import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import themeable from 'zignal-landscape/lib/themeable';
import MfeRecentIcon from 'zignal-landscape/lib/Icon/MfeRecentIcon';
import MfeIconWrapper from '../MfeIconWrapper/MfeIconWrapper';
import MfeModal from '../../../../components/MfeModal/MfeModal';

import * as actions from '../../containers/HistoricsSearchForm/HistoricsSearchForm.ducks';
import SearchRow from './SearchRow';

export const mapStateToProps = (state) => ({
  recentSearchesOpen: state.DiscoverHistorics.HistoricsSearchForm.recentSearchesOpen,
  recentSearches: state.DiscoverHistorics.Page.recentSearches,
  timezone: state.AppUser.user.timezone
});

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

const RecentSearch = ({
  styles,
  toggleRecentSearches,
  recentSearchesOpen,
  populateSearchForm,
  fetchRecentSearches,
  recentSearches,
  fetchRecentSearchResults,
  timezone,
  colors,
  clearRecentSearches
}) => {
  useEffect(() => {
    fetchRecentSearches();
  }, []);

  const clearSearch = () => {
    clearRecentSearches();
    toggleRecentSearches();
  };

  return (
    <>
      <MfeIconWrapper
        icon={MfeRecentIcon} open={!!recentSearchesOpen} onClick={toggleRecentSearches}
        disabled={!recentSearches.length} tooltipProps={{ tooltipText: 'Recent Searches' }}
      />
      <MfeModal
        isOpen={recentSearchesOpen}
        size="medium"
        onEscapePress={toggleRecentSearches}
        onBackdropClick={toggleRecentSearches}
        title="Recent Searches"
        onClose={toggleRecentSearches}
      >
        <div>
          <div className={styles.clearAll} onClick={clearSearch}><span>Clear all</span></div>
          <div className={styles.RecentSearch}>
            {recentSearches.map(({searchTerms, settings, startDate, endDate, timestamp}, index) =>
              (<SearchRow
                key={index}
                searchTerms={searchTerms}
                startDate={startDate}
                endDate={endDate}
                timestamp={timestamp}
                populateSearchForm={populateSearchForm}
                fetchRecentSearchResults={fetchRecentSearchResults}
                toggleRecentSearches={toggleRecentSearches}
                timezone={timezone}
                colors={colors}
                settings={settings || {}}
              />)
            )}
          </div>
        </div>
      </MfeModal>
    </>
  );
};

RecentSearch.propTypes = {
  styles: PropTypes.object,
  toggleRecentSearches: PropTypes.func,
  recentSearchesOpen: PropTypes.bool,
  populateSearchForm: PropTypes.func,
  recentSearches: PropTypes.array,
  fetchRecentSearchResults: PropTypes.func,
  timezone: PropTypes.string,
  colors: PropTypes.array,
  clearRecentSearches: PropTypes.func,
  fetchRecentSearches: PropTypes.func,
};

export default connect(mapStateToProps, actions, mergeProps)(themeable(RecentSearch));
